import { ILead } from 'src/interfaces/lead';
import { DIGITAL_AREA } from 'src/constants/user';
import { NEW, PREOWNED } from 'src/constants/CARTYPE';
import {
    NEWS_LEAD_TYPE,
    PREOWNEDS_LEAD_TYPE,
    TAreas,
} from 'src/constants/lead/leadTypes';

/**
 * Will return the area of the template
 *
 * @param {ILead} lead
 * @return {TAreas}
 */
export const getTemplateArea = (lead: ILead): TAreas => {
    if (lead?.type === DIGITAL_AREA) {
        if (lead.carType === NEW) return NEWS_LEAD_TYPE;
        if (lead.carType === PREOWNED) return PREOWNEDS_LEAD_TYPE;
    }

    return lead.type;
};
